
import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpContextToken } from '@angular/common/http';
import { from, throwError, EMPTY } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_AUTH)) {
    return next(req);
  }

  const authService = inject(AuthService);
  return from(authService.getToken()).pipe(
    switchMap(token => {
      if (token) {
        const cloned = req.clone({
          setHeaders: {
            Authorization: `${token}`
          }
        });
        return next(cloned);
      }
      return next(req);
    }),
    catchError(error => {
      if (error.status === 403 && 
          error.error?.success === false && 
          error.error?.error === 'Access denied: user not found') {
        void authService.logoutUserNotFound();
        return EMPTY;
      }
      
      if (error.status === 401) {
        window.location.reload();
      }
      return throwError(() => error);
    })
  );
};
